import React, { useCallback, forwardRef, useMemo } from 'react';
import classnames from 'classnames';
import { get } from 'lodash-es';
import { INVENTORY_SCROLL_TO_TOP_ANCHOR } from 'site-modules/personalized-search/constants/inventory';
import { useOnScreen } from 'site-modules/shared/hooks/use-on-screen';
import { transformSelectedFacetsForDisplaying } from 'site-modules/shared/utils/inventory/search-filter';
import { AnimatedSticky } from 'site-modules/shared/components/animated-sticky/animated-sticky';
import { FilterButton } from 'site-modules/shared/components/inventory/filters-button/filters-button';
import { SrpCardsTopPanel } from 'site-modules/personalized-search/components/srp-cards-top-panel/srp-cards-top-panel';
import { ELECTRICITY_RANGE, SORT_BY } from 'site-modules/shared/constants/allowed-inventory-request-params';
import { expandedRadiusDueToLowResultsSort } from 'site-modules/shared/constants/sort-types';

export const InventoryStickyHeader = forwardRef(
  (
    {
      facets,
      filteringByFacets,
      onFiltersButtonClick,
      onUpdateFilter,
      inventoryCount,
      isMobile,
      isDealerSrp,
      dealerName,
      selectedFilters,
      isExpandedRadiusDueToLowResultsSort,
    },
    ref
  ) => {
    const [isStickyEnabled] = useOnScreen(ref);
    const selectedFacets = useMemo(
      () =>
        !get(selectedFilters, 'sortBy') && isExpandedRadiusDueToLowResultsSort
          ? { ...selectedFilters, [SORT_BY]: [expandedRadiusDueToLowResultsSort] }
          : selectedFilters,
      [isExpandedRadiusDueToLowResultsSort, selectedFilters]
    );

    const renderFilters = useCallback(
      sticky => (
        <div className={classnames('d-flex justify-content-between align-items-center', { 'mb-1_5': !sticky })}>
          <FilterButton
            classes=""
            onFiltersBtnClick={onFiltersButtonClick}
            activeFiltersCount={transformSelectedFacetsForDisplaying(filteringByFacets).length}
          />
          <SrpCardsTopPanel
            onUpdate={onUpdateFilter}
            inventoryCount={inventoryCount}
            isMobile={isMobile}
            withRange={!!facets.find(({ type }) => type === ELECTRICITY_RANGE)}
            selectedFacets={selectedFacets}
          />
        </div>
      ),
      [onFiltersButtonClick, filteringByFacets, onUpdateFilter, inventoryCount, isMobile, facets, selectedFacets]
    );
    return (
      <>
        <h2
          id={INVENTORY_SCROLL_TO_TOP_ANCHOR}
          className={classnames('fw-bold mb-1', {
            'size-20': isMobile,
            'size-24': !isMobile,
            'text-center': !isMobile,
          })}
        >
          {isDealerSrp && dealerName ? dealerName : 'Shop inventory near you'}
        </h2>
        <AnimatedSticky
          stickyClassName="py-0_5 px-1 px-md-1_75"
          stickyFragment={renderFilters}
          hideSticky={!inventoryCount || !isStickyEnabled}
        >
          {renderFilters()}
        </AnimatedSticky>
      </>
    );
  }
);
